import React from 'react';
import { Box, BoxProps } from '@planitgeo/treeplotter-ui-library';

export default function Main({ children, sx, ...other }: BoxProps) {
  const { ref, ...rest } = other as BoxProps & { ref?: React.Ref<unknown> };
  return (
    <Box
      component="main"
      ref={ref as React.Ref<HTMLDivElement> | undefined}
      sx={{
        flexGrow: 1,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
